/* creta-product.js - gallery, variant picker, qty, share for Creta Mart product page */
(function () {
  function init(root) {
    var jsonEl = root.querySelector('[data-creta-variants]');
    var variants = [];
    try { variants = JSON.parse(jsonEl ? jsonEl.textContent : '[]'); } catch (e) {}
    var track = root.querySelector('[data-creta-track]');
    var dots = root.querySelectorAll('[data-creta-dots] .creta-dot');
    var groups = root.querySelectorAll('[data-creta-option]');
    var idInput = root.querySelector('[data-creta-variant-id]');
    var offer = root.querySelector('[data-creta-offer]');
    var addBtn = root.querySelector('[data-creta-add]');
    var buyBtn = root.querySelector('[data-creta-buy]');

    if (track && dots.length) {
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      }, { passive: true });
      dots.forEach(function (d, n) {
        d.addEventListener('click', function () { track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' }); });
      });
    }

    function chosen() {
      return Array.prototype.map.call(groups, function (g) {
        var c = g.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function apply() {
      var vals = chosen();
      groups.forEach(function (g, i) {
        var l = g.querySelector('[data-creta-opt-label]');
        if (l && vals[i]) l.textContent = vals[i];
      });
      var v = variants.find(function (x) {
        return x.options.every(function (o, i) { return o === vals[i]; });
      });
      if (!v) { addBtn.disabled = true; buyBtn.disabled = true; return; }
      idInput.value = v.id;
      var tpl = root.querySelector('template[data-creta-variant="' + v.id + '"]');
      if (tpl) offer.innerHTML = tpl.innerHTML;
      addBtn.disabled = !v.available;
      buyBtn.disabled = !v.available;
      addBtn.textContent = v.available ? addBtn.getAttribute('data-label') : addBtn.getAttribute('data-sold');
      try { history.replaceState(null, '', window.location.pathname + '?variant=' + v.id); } catch (e) {}
      if (v.featured_media && track) {
        var s = root.querySelector('[data-media-id="' + v.featured_media.id + '"]');
        if (s) track.scrollTo({ left: s.offsetLeft, behavior: 'smooth' });
      }
    }
    groups.forEach(function (g) { g.addEventListener('change', apply); });

    var qty = root.querySelector('[data-creta-qty]');
    var qv = root.querySelector('[data-creta-qty-val]');
    if (qty && qv) qty.addEventListener('change', function () { qv.textContent = qty.value; });

    var more = root.querySelector('[data-creta-seemore]');
    if (more) more.addEventListener('click', function () {
      root.querySelectorAll('[data-creta-extra]').forEach(function (n) { n.hidden = false; });
      more.hidden = true;
    });

    var wish = root.querySelector('[data-creta-wish]');
    if (wish) wish.addEventListener('click', function () {
      var on = wish.getAttribute('aria-pressed') !== 'true';
      wish.setAttribute('aria-pressed', on ? 'true' : 'false');
      wish.style.color = on ? '#cc0c39' : '';
      wish.querySelector('path').setAttribute('fill', on ? '#cc0c39' : 'none');
    });
    var share = root.querySelector('[data-creta-share]');
    if (share) share.addEventListener('click', function () {
      if (navigator.share) { navigator.share({ title: document.title, url: window.location.href }).catch(function () {}); }
      else if (navigator.clipboard) { navigator.clipboard.writeText(window.location.href); }
    });
  }
  function boot() { document.querySelectorAll('[data-creta-pm]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();